import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {HttpClient, HttpParams} from '@angular/common/http';
import {MatLegacyPaginator as MatPaginator} from '@angular/material/legacy-paginator';
import {MatLegacyTableDataSource as MatTableDataSource} from '@angular/material/legacy-table';
import {debounceTime} from 'rxjs/operators';
import {EnvService} from '../services/env.service';
import {CmdbApplicationFilter} from './cmdbApplications.filter';
import { SettingsPersistenceService } from '../services/settings-persistence.service';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'micro-cmdb-applications',
  templateUrl: './cmdbApplications.component.html'
})
export class CmdbApplicationsComponent implements OnInit, OnDestroy {
  dataSource = new MatTableDataSource<any>();
  applicationTagNames = new Map<string, string>();

  @ViewChild(MatPaginator, {static: true}) paginator!: MatPaginator;
  pageSettings!: SettingsPersistenceService;
  filter = new CmdbApplicationFilter(this.auth);

  constructor(public auth: AuthService, private env: EnvService, private http: HttpClient) {
  }

  ngOnInit(): void {
    // Setup the settings persistence service for this page
    this.pageSettings = new SettingsPersistenceService(sessionStorage, 'micro.cmdbApplications');
    this.pageSettings
      .setFilter(this.filter)
      .setPaginator(this.paginator)
      .init();

    // Subscribe to filter changes with a debounce time to avoid excessive reloads
    this.filter.anyChange.pipe(debounceTime(500)).subscribe(change => {
      this.reload();
    });

    // Initial data load
    this.reload();
  }

  ngOnDestroy(): void {
  }

  reload(): void {
    const params: HttpParams = this.filter.getParams()
      .set('page', String(this.paginator.pageIndex || 0))
      .set('size', String(this.paginator.pageSize || 20));

    this.http.get(`${this.env.e.url}/domain/cmdbApplications`, {params}).subscribe(data => {
      const page = data as any;
      this.dataSource.data = page.content;
      this.paginator.pageIndex = page.number;
      this.paginator.pageSize = page.size;
      this.paginator.length = page.totalElements;
    });
  }
}
